import { render } from "./ContactControlTable.vue?vue&type=template&id=965e44f6"
import script from "./ContactControlTable.vue?vue&type=script&lang=js"
export * from "./ContactControlTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__